import React from 'react'
import PropTypes from 'prop-types'
import Courses from './Courses'
import TotalsSection from './TotalsSection'
import Caption3 from '../typography/captions/Caption3'
import NoQuestsMatchYourSearch from '../mini/NoQuestsMatchYourSearch'
import { hasNoQuests } from '../../utils/productionstatus'

const Body = props => {
  return props.hasActiveFilters && hasNoQuests(props.productionStatusStats) ? (
    <NoQuestsMatchYourSearch text="No quests match your search." />
  ) : (
    <React.Fragment>
      <TotalsSection totalCounts={props.totalCounts} />
      <div style={{ marginBottom: '15px' }}>
        <Caption3 style={{ marginLeft: '21px', display: 'inline-block' }}>
          Intended Journeys
        </Caption3>
        <Caption3 style={{ marginLeft: '101px', display: 'inline-block' }}>
          Total Quests
        </Caption3>
      </div>
      <Courses
        productionStatusStats={props.productionStatusStats}
        dispatch={props.dispatch}
        hasActiveFilters={props.hasActiveFilters}
        clickHandler={props.clickHandler}
        levelFilters={props.levelFilters}
      />
    </React.Fragment>
  )
}

Body.propTypes = {
  productionStatusStats: PropTypes.array.isRequired,
  totalCounts: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  hasActiveFilters: PropTypes.bool.isRequired,
  clickHandler: PropTypes.func.isRequired,
  levelFilters: PropTypes.array.isRequired
}

export default Body



// WEBPACK FOOTER //
// ./src/components/productionstatus/Body.js